import axios from 'axios';
const RESOURCE_NAME = '/abouts';

export default {
    GetAbout(local) {
        return axios.get(`${RESOURCE_NAME}/${local}`)
    },
}